/**
 * The creator's bio in the profile header (owner, 2026-10-21): the full text with its line breaks, never cut with "…".
 * A very long bio (more than BIO_FOLD_LINES lines, or about that much text) starts folded with a "more" / "less" toggle.
 * The stored bio is Instagram's full `biography` (bounded at 1,000 characters; Instagram allows 150).
 */
import { useState } from 'react';

export const BIO_FOLD_LINES = 6;
const BIO_FOLD_CHARS = 480;

/** Whether the bio is long enough to start folded. */
export const bioIsLong = (bio: string): boolean => bio.split('\n').length > BIO_FOLD_LINES || bio.length > BIO_FOLD_CHARS;

export function CreatorBio({ bio }: { bio: string }) {
  const long = bioIsLong(bio);
  const [open, setOpen] = useState(false);
  return (
    <div className="max-w-2xl text-sm">
      <p className={`whitespace-pre-line break-words${long && !open ? ' line-clamp-6' : ''}`}>{bio}</p>
      {long && (
        <button type="button" className="text-xs font-semibold text-primary hover:underline" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
          {open ? 'less' : 'more'}
        </button>
      )}
    </div>
  );
}
